// packages/shared/src/actions/financesOverview.ts
import axios from "axios";
import { API_URL } from "../config";
import { user } from "./actions_helper";

export interface FinancesOverviewStats {
    invoices_net_total_formatted: string;
    invoices_gross_total_formatted: string;
    offers_net_total_formatted: string;
    offers_gross_total_formatted: string;
    invoices_count: number;
    offers_count: number;
    offers_accepted_count: number;
    protocols_count: number;
}

export async function fetchFinancesOverview(
    from: string,
    to: string
): Promise<FinancesOverviewStats> {
    const url = `${API_URL}/finances/overview.json?from=${from}&to=${to}`;
    const response = await axios.get(url, {
        headers: { authorization: user().token },
    });
    return response.data;
}
